module.exports = __webpack_public_path__ + "img/00.15e76fef.png";